import React, { useState } from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  FDBox, FDSecondaryActionButton, FDSecondaryActionIconButton, FDStack, FDTitleText, FDDialogContent, FDDialog,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { MobileStepper } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import { DataValueMap } from 'Helpers/Testing';
import theme from 'Theme';
import { makeStyles } from 'Components/ComponentLibrary/Styles';
import RichTextDisplay from 'Components/UI/Overrides/RichTextDisplay';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';


const useStyles = makeStyles({
  mobileStepper: {
    background: 'transparent',
    padding: 0,
    fontSize: theme.typography.subtitle1.fontSize,
  },
  overlay: {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: theme.radius.md,
      zIndex: 10,
      background: `transparent linear-gradient(180deg, ${theme.palette.facet.clear} 50%, ${theme.palette.common.white} 100%) 0% 0% no-repeat padding-box;`,
    },
  },
});

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDTitleText,
    _customProps: { color: 'textSecondary', size: 'md' },
  }, overrideReadOnly)
  .nameOverride(['body'], {
    _component: () => RichTextDisplay,
  }, overrideReadOnly);


const TransitionsDashboardPageMeetingTranscriptLayout = ({
  resource,
  currentStep,
  stepsCount,
  setCurrentStep,
}) => {
  const classes = useStyles();

  const hasPreviousStep = currentStep > 0;
  const hasNextStep = currentStep < stepsCount - 1;

  const [isOpen, setIsOpen] = useState(false);

  const closeDialog = () => setIsOpen(false);
  const openDialog = () => setIsOpen(true);

  return (
    <FDBox padding={500} flex={1}>
      <FDStack alignItems={'center'} justifyContent={'center'}>
        <FDBox>
          <MetaControl attrName={'title'} metaOverrideSet={metaOverride} resource={resource} />
        </FDBox>
      </FDStack>
      {(hasPreviousStep || hasNextStep) && <MobileStepper
        {...DataValueMap.init('transitions-dashboard-page-meeting-transcripts-mobile-stepper').build()}
        className={classes.mobileStepper}
        position={'static'}
        backButton={hasPreviousStep
          ? <FDSecondaryActionIconButton
            {...DataValueMap.init('transitions-dashboard-page-meeting-transcripts-mobile-stepper-prev').build()}
            size={'lg'}
            icon={'chevronLeft'}
            onClick={() => setCurrentStep(currentStep - 1)}
          />
          : <FDBox width={'48px'} height={'48px'} />}
        nextButton={hasNextStep
          ? <FDSecondaryActionIconButton
            {...DataValueMap.init('transitions-dashboard-page-meeting-transcripts-mobile-stepper-next').build()}
            size={'lg'}
            icon={'chevronRight'}
            onClick={() => setCurrentStep(currentStep + 1)}
          />
          : <FDBox width={'48px'} height={'48px'} />}
        activeStep={currentStep}
        steps={stepsCount}
        variant={stepsCount < 6 ? 'dots' : 'text'}
      />}
      <FDBox maxHeight={'400px'} overflow={'hidden'}>
        <Box className={classes.overlay}>
          <MetaControl attrName={'body'} metaOverrideSet={metaOverride} resource={resource} />
        </Box>
      </FDBox>
      <FDSecondaryActionButton label={'Read More'} onClick={openDialog} />
      <FDDialog
        open={isOpen}
        onClose={closeDialog}
        closeOnBackdropClick
      >
        <FDDialogContent>
          <MetaControl attrName={'body'} metaOverrideSet={metaOverride} resource={resource} />
        </FDDialogContent>
      </FDDialog>
    </FDBox>
  );
};

TransitionsDashboardPageMeetingTranscriptLayout.defaultProps = {};

TransitionsDashboardPageMeetingTranscriptLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  currentStep: PropTypes.number.isRequired,
  stepsCount: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default TransitionsDashboardPageMeetingTranscriptLayout;
